import React from "react";
import { colorNota } from "../componentes/Notas";

const claseMeter = {
  success: "esen-meter-fill",
  warning: "esen-meter-fill esen-meter-fill--warning",
  danger: "esen-meter-fill esen-meter-fill--danger",
};

const CarNotasDetalle = ({ materia, nota, matricula }) => {
  const estado = colorNota(nota);
  return (
    <tr>
      <td>{materia}</td>
      <td>
        <div className="esen-meter">
          <span className="esen-meter-num">{nota.toFixed(1)}</span>
          <div className="esen-meter-track">
            <div
              className={claseMeter[estado]}
              style={{ width: `${Math.min(Math.max(nota * 10, 0), 100)}%` }}
            ></div>
          </div>
        </div>
      </td>
      <td>
        <span className="esen-chip esen-chip--neutral">
          {/^\d+$/.test(String(matricula).trim()) ? `${String(matricula).trim()}ª matrícula` : matricula}
        </span>
      </td>
    </tr>
  );
};

export default CarNotasDetalle;
